import { cloneDeep, get, isArray, set } from 'lodash';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { AUSGABE_KATEGORIE, KOSTEN_ARTEN, KOSTEN_POSITION } from 'src/lib/constants/constant';
import { addIndexesToPath, enumT, getIDFromResponseOption, groupKostenByPosition } from 'src/utils/helper';
import { calculateGesamtSumme, calculateProjektDauer, calculateProjektStartJahr } from '../commonFormulas';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenKategoriechema from 'src/lib/paths/kostenkategorie_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenPositionSchema.attributes;
const KK_P = KostenKategoriechema.attributes;

export const executeEmobLisFormulas = (
	application: any,
	kostenKategories: any,
	vonTag: number,
	vonMonat: string,
	bisTag: number,
	bisMonat: string
) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);

	// TODO: All the other Formulas should written in the same way as the ProjektJahr and Projektdauer.
	// This function should actually return the complete application.
	// And in this applicaiton should be overwritten in the OnlineAntrag.tsx in the update State
	let calcultedProjkJahr = calculateProjektStartJahr(application, vonTag, vonMonat);
	let calcultedProjkdauer = calculateProjektDauer(application, vonTag, vonMonat, bisTag, bisMonat);
	if (isArray(calcultedProjkJahr)) {
		for (let ele of calcultedProjkJahr) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	if (isArray(calcultedProjkdauer)) {
		for (let ele of calcultedProjkdauer) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkJahr);
	result.push(...calcultedProjkdauer);

	if (get(appCopy, P.Allgemein_Projektdauerin_Jahren.path) > 0) {
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Investitionskosten)) {
			let calculatedInvestitionsKosten: any = [];
			calculatedInvestitionsKosten = calculateInvestitionKosten(appCopy, kostenKategories);

			result.push(...calculatedInvestitionsKosten);
			for (let ele of calculatedInvestitionsKosten) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
			let calculatedEigenmittel: any = [];
			calculatedEigenmittel = calculateEigenmittel(appCopy, kostenKategories);
			result.push(...calculatedEigenmittel);
			for (let ele of calculatedEigenmittel) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}

		// Berechnet die Förderquote auf Jarhen aufgeteilt für Antragsteller und jede Partner
		let calculatedFoerderQuote = calculateFoerderquote(appCopy);
		result.push(...calculatedFoerderQuote);
		for (let ele of calculatedFoerderQuote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Jahrenaufteilung für Ausgaben, Einnahmen, Zuwendung und Förderquote
		let calculatedJahresaufteilung = calculateJahresAufteilung(appCopy);
		result.push(...calculatedJahresaufteilung);
		for (let ele of calculatedJahresaufteilung) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		// Berechnet die Gesamt Förderquote für Antragsteller und jede Partner
		let calculatedGesamtFoerderquote = calculateGesamtFoerderquote(appCopy);
		result.push(...calculatedGesamtFoerderquote);
		for (let ele of calculatedGesamtFoerderquote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}

		let calculatedGesamtSummeSkizze = calculateGesamtSumme(appCopy);
		if (isArray(calculatedGesamtSummeSkizze)) {
			for (let ele of calculatedGesamtSummeSkizze) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}
		result.push(...calculatedGesamtSummeSkizze);
	}

	return result;
};

function calculateInvestitionKosten(application: any, kostenKategories: any) {
	let result: any = [];
	const allKostenPositionARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	for (let i = 0; i < allKostenPositionARR.length; i++) {
		const eachInvestitionsKosten = allKostenPositionARR[i];
		if (get(eachInvestitionsKosten, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten) {
			// Resetting the other component like Eletrofahrzeug or Netzanschluss... if the Kostenkategorie changes
			const selectedAusgabenKategorie = getKostenKategorieForInvestiv(
				get(eachInvestitionsKosten, KP_P.Allgemein_Kostenkategorie.path),
				kostenKategories
			);
			if (selectedAusgabenKategorie === AUSGABE_KATEGORIE.NetzanschlussUndErdarbeiten) {
				result.push(
					// Resetting the value of Ladeinfrastruktur und Energie Speicher
					{
						path: addIndexesToPath(
							P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Ladeinfrastruktur_Lis.path,
							[`${i}`],
							['Foerderantrag_Kostenpositions']
						),
						value: null,
					},
					{
						path: addIndexesToPath(
							P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_LIS_Energiespeicher.path,
							[`${i}`],
							['Foerderantrag_Kostenpositions']
						),
						value: null,
					}
				);
			}

			if (selectedAusgabenKategorie === AUSGABE_KATEGORIE.LadeTankInfrastruktur) {
				result.push(
					// Resetting the value of Netzanschluss und Energie Speicher
					{
						path: addIndexesToPath(
							P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Netzanschluss_Und_Erdarbeiten.path,
							[`${i}`],
							['Foerderantrag_Kostenpositions']
						),
						value: null,
					},
					{
						path: addIndexesToPath(
							P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_LIS_Energiespeicher.path,
							[`${i}`],
							['Foerderantrag_Kostenpositions']
						),
						value: null,
					}
				);
			}

			if (selectedAusgabenKategorie === AUSGABE_KATEGORIE.Energiespeicher) {
				result.push(
					// Resetting the value of Netzanschluss und Ladeinfrastruktur
					{
						path: addIndexesToPath(
							P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Netzanschluss_Und_Erdarbeiten.path,
							[`${i}`],
							['Foerderantrag_Kostenpositions']
						),
						value: null,
					},
					{
						path: addIndexesToPath(
							P.Foerderantrag_Kostenpositions.schema.attributes.Kalkulation_Ladeinfrastruktur_Lis.path,
							[`${i}`],
							['Foerderantrag_Kostenpositions']
						),
						value: null,
					}
				);
			}

			// Summing for the Allgemein Kosten Pro Jahr Block
			const allKostenProJahrInvestitionARR = get(
				application,
				addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions']
				),
				[]
			);

			let KalkulationInvestivProJahr = transformInvestitionsKostenData(
				allKostenProJahrInvestitionARR,
				get(application, P.Allgemein_Projektstart_Jahr.path),
				get(application, P.Allgemein_Projektdauerin_Jahren.path)
			);

			result.push(
				// Selected Ausgabenkategorie in das Feld Bezeichnung speichern
				{
					path: addIndexesToPath(
						P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung.path,
						[`${i}`],
						['Foerderantrag_Kostenpositions']
					),
					value: enumT(selectedAusgabenKategorie),
				},
				{
					path: addIndexesToPath(
						P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Ausgabekategorie.path,
						[`${i}`],
						['Foerderantrag_Kostenpositions']
					),
					value: selectedAusgabenKategorie,
				},
				{
					path: addIndexesToPath(
						P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
						[`${i}`],
						['Foerderantrag_Kostenpositions']
					),
					value: get(KalkulationInvestivProJahr, 'KostenProJahr'),
				},
				{
					path: addIndexesToPath(
						P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
						[`${i}`],
						['Foerderantrag_Kostenpositions']
					),
					value: get(KalkulationInvestivProJahr, 'gesamtSumme'),
				}
			);
		}
	}
	return result;
}
function calculateEigenmittel(application: any, kostenKategories: any) {
	let result: any = [];

	const allKostenPositionARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	for (let i = 0; i < allKostenPositionARR.length; i++) {
		const eachEigenmittel = allKostenPositionARR[i];
		if (get(eachEigenmittel, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel) {
			const allKostenProJahrEigenmittelARR = get(
				application,
				addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions']
				),
				[]
			);

			let KalkulationAllgemeinProJahr = transformAllgemeinKostenProJahrData(
				allKostenProJahrEigenmittelARR,
				get(application, P.Allgemein_Projektstart_Jahr.path),
				get(application, P.Allgemein_Projektdauerin_Jahren.path)
			);

			result.push({
				path: addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions']
				),
				value: get(KalkulationAllgemeinProJahr, 'KostenProJahr'),
			});
			result.push({
				path: addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions']
				),
				value: get(KalkulationAllgemeinProJahr, 'gesamtSumme'),
			});

			// Kostenkategories
			const selectedKostenKategorieId = getIDFromResponseOption(get(eachEigenmittel, KP_P.Allgemein_Kostenkategorie.path, ''));
			const selectedKostenKategorie_Obj = kostenKategories.find((ele: any) => get(ele, 'id') === selectedKostenKategorieId);
			const selectedKostenKategorieName = get(selectedKostenKategorie_Obj, KK_P.Allgemein_Bezeichnung.path, '');
			result.push({
				path: addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions']
				),
				value: selectedKostenKategorieName,
			});
		}
	}
	return result;
}
function calculateFoerderquote(application: any) {
	let result: any = [];
	const allKostenPositionsARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	const AntragstellerId = get(application, `${P.Antragstellende_Organisation.path}.id`);
	const allKostenpositionVonAntragsteller = allKostenPositionsARR.filter((ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === AntragstellerId);
	result.push({
		path: P.Antragstellende_Organisation_Foerderquote.path,
		value: calculateFoerderquoteData(allKostenpositionVonAntragsteller),
	});

	return result;
}
function calculateJahresAufteilung(application: any) {
	let result: any = [];
	const allKostenposition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	const calculatedJahreaufteilung = calculateFinancials(allKostenposition);
	result.push(
		{
			path: P.Allgemein_Geplante_Projektausgaben.path,
			value: get(calculatedJahreaufteilung, 'gesamtAusgaben'),
		},
		{
			path: P.Allgemein_Beantragte_Zuwendung.path,
			value: get(calculatedJahreaufteilung, 'gesamtZuwendung'),
		},
		{ path: P.Bewilligung_Jahresaufteilung.path, value: get(calculatedJahreaufteilung, 'Jahrenaufteilung') }
	);
	return result;
}
function calculateGesamtFoerderquote(application: any) {
	let result: any = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	// Förderquote für Antragsteller
	const allAusgabenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe'
	);

	const allEinnahmenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme'
	);

	const ausgabenGesamtAntragsteller = allAusgabenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmenGesamtAntragsteller = allEinnahmenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamtAntragsteller = ausgabenGesamtAntragsteller - einnahmenGesamtAntragsteller;
	const foerderQuoteAntragsteller = ausgabenGesamtAntragsteller !== 0 ? (zuwendungGesamtAntragsteller / ausgabenGesamtAntragsteller) * 100 : 0;

	result.push({
		path: P.Orga_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteAntragsteller) ? foerderQuoteAntragsteller.toFixed(2) : 0,
	});

	// FörderQuote unabhängig von Antragsteller oder Parter
	// Gesamt aussicht
	const allAusgaben_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe');
	const allEinnahme_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme');

	const ausgabenGesamt = allAusgaben_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmennGesamt = allEinnahme_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamt = ausgabenGesamt - einnahmennGesamt;
	const foerderQuoteGesamt = ausgabenGesamt !== 0 ? (zuwendungGesamt / ausgabenGesamt) * 100 : 0;

	result.push({
		path: P.Bewilligung_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteGesamt) ? foerderQuoteGesamt.toFixed(2) : 0,
	});
	return result;
}

/*
 ***************************************************************************************************************
 * ************************ HELPER FUNCTIONS *******************************************************************
 * *************************************************************************************************************
 */
const calculateFoerderquoteData = (data: any[]) => {
	// Extract all unique years from the data
	const years = Array.from(new Set(data.flatMap((item) => item.attributes.Allgemein_Kosten_Pro_Jahr.map((k: any) => k.Zelle_1))));

	// Calculate Foerderquote for each year
	const result = years.map((year) => {
		let sumAusgabe = 0;
		let sumEinnahme = 0;

		data.forEach((item) => {
			get(item, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).forEach((kosten: any) => {
				if (kosten.Zelle_1 === year) {
					const value = parseFloat(kosten.Zelle_2);
					if (!isNaN(value)) {
						if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe') {
							sumAusgabe += value;
						} else if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Einnahme') {
							sumEinnahme += value;
						}
					}
				}
			});
		});

		const foerderquote = sumAusgabe !== 0 ? ((sumAusgabe - sumEinnahme) / sumAusgabe) * 100 : 0;

		return {
			Projektjahr: year,
			Foerderquote_403741: !isNaN(foerderquote) ? parseFloat(foerderquote.toFixed(2)) : 0, // Round to two decimal places
		};
	});

	return result;
};
function getKostenKategorieForInvestiv(valueFromDB: any, kostenKategories: any): string {
	if (typeof valueFromDB === 'object') {
		const givenKategor = kostenKategories.find((ele: any) => ele.id === valueFromDB.id);
		return get(givenKategor, 'attributes.Allgemein_Ausgabekategorie');
	} else {
		const givenKategor = kostenKategories.find((ele: any) => ele.id === valueFromDB);
		return get(givenKategor, 'attributes.Allgemein_Ausgabekategorie');
	}
}
function transformInvestitionsKostenData(data: any, projektJahrStart: number, ProjektJahrDauer: number) {
	// Filter and adjust the data length to match ProjektJahrDauer
	let adjustedData = data.slice(0, ProjektJahrDauer);

	// If the adjusted data length is less than ProjektJahrDauer, add missing years
	for (let i = adjustedData.length; i < ProjektJahrDauer; i++) {
		adjustedData.push({
			Zelle_1: projektJahrStart + i,
			Zelle_2: 0, // Default value if not provided
		});
	}

	// Adjust Zelle_1 to start from projektJahrStart and increment
	adjustedData = adjustedData.map((item: any, index: number) => ({
		...item,
		Zelle_1: projektJahrStart + index,
		Zelle_2: parseFloat(item.Zelle_2) || 0,
	}));

	// Calculate gesamtSumme
	const gesamtSumme = adjustedData.reduce((sum: any, item: any) => sum + item.Zelle_2, 0).toFixed(2);

	// Format adjusted data with 2 decimal places
	const KostenProJahr = adjustedData.map((item: any) => ({
		...item,
		Zelle_2: item.Zelle_2.toFixed(2),
	}));

	return {
		gesamtSumme: parseFloat(gesamtSumme).toFixed(2),
		KostenProJahr,
	};
}

function transformAllgemeinKostenProJahrData(data: any, projektJahrStart: number, ProjektJahrDauer: number) {
	// Filter and adjust the data length to match ProjektJahrDauer
	let adjustedData = data.slice(0, ProjektJahrDauer);

	// If the adjusted data length is less than ProjektJahrDauer, add missing years
	for (let i = adjustedData.length; i < ProjektJahrDauer; i++) {
		adjustedData.push({
			Zelle_1: projektJahrStart + i,
			Zelle_2: 0, // Default value if not provided
		});
	}

	// Adjust Zelle_1 to start from projektJahrStart and increment
	adjustedData = adjustedData.map((item: any, index: number) => ({
		...item,
		Zelle_1: projektJahrStart + index,
		Zelle_2: parseFloat(item.Zelle_2) || 0,
	}));

	// Calculate gesamtSumme
	const gesamtSumme = adjustedData.reduce((sum: any, item: any) => sum + item.Zelle_2, 0).toFixed(2);

	// Format adjusted data with 2 decimal places
	const KostenProJahr = adjustedData.map((item: any) => ({
		...item,
		Zelle_2: item.Zelle_2.toFixed(2),
	}));

	return {
		gesamtSumme: parseFloat(gesamtSumme).toFixed(2),
		KostenProJahr,
	};
}

function calculateFinancials(data: any) {
	const result: any = {};

	let gesamtAusgaben = 0;
	let gesamtEinnahme = 0;

	data.forEach((item: any) => {
		const { Allgemein_Kostenposition, Allgemein_Kosten_Pro_Jahr } = item.attributes;

		Allgemein_Kosten_Pro_Jahr.forEach((yearlyCost: any) => {
			const year = yearlyCost.Zelle_1;
			const amount = parseFloat(yearlyCost.Zelle_2) || 0;

			if (!result[year]) {
				result[year] = {
					Projektjahr: year,
					Ausgaben: 0,
					Eigen_45_Und_Drittmittel: 0,
				};
			}

			if (Allgemein_Kostenposition === 'Ausgabe') {
				result[year].Ausgaben += amount;
				gesamtAusgaben += amount;
			} else if (Allgemein_Kostenposition === 'Einnahme') {
				result[year].Eigen_45_Und_Drittmittel += amount;
				gesamtEinnahme += amount;
			}
		});
	});

	const Jahrenaufteilung = Object.values(result).map((item: any) => {
		const { Ausgaben, Eigen_45_Und_Drittmittel } = item;
		const Zuwendung = (Ausgaben || 0) - (Eigen_45_Und_Drittmittel || 0);
		const Foerderquote_403741 = Ausgaben > 0 ? (Zuwendung / Ausgaben) * 100 : 0;

		return {
			...item,
			Ausgaben: Ausgaben.toFixed(2),
			Eigen_45_Und_Drittmittel: Eigen_45_Und_Drittmittel.toFixed(2),
			Zuwendung: Zuwendung.toFixed(2),
			Foerderquote_403741: Foerderquote_403741.toFixed(2),
		};
	});

	const gesamtZuwendung = gesamtAusgaben - gesamtEinnahme;
	const gesamtFoerderQuote = gesamtAusgaben > 0 ? (gesamtZuwendung / gesamtAusgaben) * 100 : 0;

	return {
		gesamtAusgaben: !isNaN(gesamtAusgaben) ? gesamtAusgaben.toFixed(2) : 0,
		gesamtEinnahme: !isNaN(gesamtEinnahme) ? gesamtEinnahme.toFixed(2) : 0,
		gesamtZuwendung: !isNaN(gesamtZuwendung) ? gesamtZuwendung.toFixed(2) : 0,
		gesamtFoerderQuote: !isNaN(gesamtFoerderQuote) ? gesamtFoerderQuote.toFixed(2) : 0,
		Jahrenaufteilung,
	};
}
